import { render, staticRenderFns } from "./SignPlan.vue?vue&type=template&id=1639fd1b&scoped=true"
import script from "./SignPlan.vue?vue&type=script&lang=js"
export * from "./SignPlan.vue?vue&type=script&lang=js"
import style0 from "./SignPlan.vue?vue&type=style&index=0&id=1639fd1b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1639fd1b",
  null
  
)

export default component.exports